<template>
  <Modal
    title="Add Attribute Value"
    modalId="create-modal9"
    @submit="submitAttributeValue"
    @cancel="resetForm"
  >
    <form @submit.prevent="submitAttributeValue">
      <div class="mb-3">
        <label class="form-label">
          Attribute value <span class="text-danger">*</span>
        </label>
        <input
          type="text"
          v-model="form.value"
          class="form-control"
          :disabled="!attributeId"
        />
        <div v-if="errors.value" class="text-danger mt-2">
          <span>{{ errors.value }}</span>
        </div>
      </div>
      <div v-if="errorMessage" class="text-danger mt-2">
        {{ errorMessage }}
      </div>
    </form>
  </Modal>
</template>

<script>
import Modal from "@/components/common/Modal.vue";

export default {
  components: {
    Modal,
  },

  props: {
    attributeId: {
      type: [Number, String],
      default: null,
    },
  },

  data() {
    return {
      form: {
        value: "",
      },
      errors: {},
      errorMessage: "",
    };
  },

  methods: {
    async submitAttributeValue() {
      this.errors = {};
      this.errorMessage = "";

      if (!this.attributeId) {
        this.errorMessage = "Please select an attribute first";
        return;
      }

      const value = this.form.value.trim();
      if (!value) {
        this.errors.value = this.$t("error.required");
        return;
      }

      try {
        const res = await this.$axios.post(
          `/attributes/${this.attributeId}/add-values/`,
          { values: [value] }
        );

        const data = res.data || {};

        if (data.skipped?.length) {
          this.errors.value = `${data.skipped.join(", ")} already exists`;
          return;
        }

        const modal = document.getElementById("create-modal9");
        const modalInstance = bootstrap.Modal.getInstance(modal);
        if (modalInstance) modalInstance.hide();

        this.$emit("create_success", {
          attributeId: this.attributeId,
          created: data.created || [value],
        });
        this.resetForm();
      } catch (error) {
        if (error.response?.data?.error) {
          this.errorMessage = error.response.data.error;
        } else if (error.response?.data?.detail) {
          this.errorMessage = error.response.data.detail;
        } else if (error.response?.data?.values) {
          this.errors.value = Array.isArray(error.response.data.values)
            ? error.response.data.values[0]
            : error.response.data.values;
        } else {
          this.errorMessage = "Failed to add attribute value";
        }
      }
    },

    resetForm() {
      this.form.value = "";
      this.errors = {};
      this.errorMessage = "";
    },
  },
};
</script>
